/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  EnvironmentHealthcheck,
  EnvironmentHealthcheck$inboundSchema,
} from "./environmenthealthcheck.js";
import {
  EnvironmentShutdownSignal,
  EnvironmentShutdownSignal$inboundSchema,
} from "./environmentshutdownsignal.js";
import {
  EnvironmentUpstreamProtocol,
  EnvironmentUpstreamProtocol$inboundSchema,
} from "./environmentupstreamprotocol.js";

/**
 * Runtime settings that control how the container runs.
 *
 * @remarks
 * Omitted until the environment has runtime settings.
 */
export type EnvironmentRuntime = {
  /**
   * Port the container listens on.
   *
   * @remarks
   */
  port: number;
  /**
   * CPU allocation in vCPUs (1 = one vCPU, 0.5 = half a vCPU).
   *
   * @remarks
   */
  vCpus: number;
  /**
   * Memory allocation in mebibytes.
   *
   * @remarks
   */
  memoryMib: number;
  /**
   * Ephemeral storage allocation in mebibytes.
   *
   * @remarks
   */
  storageMib: number;
  /**
   * Container entrypoint command override.
   *
   * @remarks
   */
  command: Array<string>;
  healthcheck?: EnvironmentHealthcheck | undefined;
  /**
   * Signal sent to the container on shutdown.
   *
   * @remarks
   */
  shutdownSignal: EnvironmentShutdownSignal;
  /**
   * Protocol used to reach the container.
   *
   * @remarks
   */
  upstreamProtocol: EnvironmentUpstreamProtocol;
  /**
   * Path to the OpenAPI spec served by the container, if any.
   *
   * @remarks
   */
  openapiSpecPath?: string | undefined;
};

/** @internal */
export const EnvironmentRuntime$inboundSchema: z.ZodType<
  EnvironmentRuntime,
  z.ZodTypeDef,
  unknown
> = z.object({
  port: z.number().int(),
  vCpus: z.number(),
  memoryMib: z.number().int(),
  storageMib: z.number().int(),
  command: z.array(z.string()),
  healthcheck: EnvironmentHealthcheck$inboundSchema.optional(),
  shutdownSignal: EnvironmentShutdownSignal$inboundSchema,
  upstreamProtocol: EnvironmentUpstreamProtocol$inboundSchema,
  openapiSpecPath: z.string().optional(),
});

export function environmentRuntimeFromJSON(
  jsonString: string,
): SafeParseResult<EnvironmentRuntime, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EnvironmentRuntime$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EnvironmentRuntime' from JSON`,
  );
}
